import Request from "@/common/net/request.js";
const request = new Request();
// 未出账订单列表
export function getPage(data) {
  return request.send({
    url: `/pmy/freight/reconciliation/order/un-reconciled/orders`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 平台生成对账单
export function reconciliationOrder(data) {
  return request.send({
    url: `/pmy/freight/reconciliation/order/platform`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
